import React from 'react';
import {Avatar, Card, CardActionArea, CardContent, Chip, Tooltip, Typography} from "@mui/material";
import PlaceTwoToneIcon from "@mui/icons-material/PlaceTwoTone";
import {innerStyle} from "../../../../../styles/pages/home/MaterialYouBaseStyle";
import {useTheme} from "@mui/material/styles";

export const EventoCard = ({title, subtitle, users, place, color, setEvento}) => {
	const classes = innerStyle();
	let theme = useTheme();
	
	return (
		<React.Fragment>
			<Card style={{
				backgroundColor: color[100],
				color: color[900],
				borderRadius: 22,
				width: "100%",
			}} className={classes.shadowOnHover}>
				<CardActionArea style={{height: "100%", padding: 4}} onClick={() => setEvento({
					evento: title,
					note: subtitle,
					partecipanti: users,
					color: 2,
				})}>
					<CardContent style={{position: "relative", paddingBottom: 26}}>
						<Typography variant="subtitle2">
							<b>{title}</b>
						</Typography>
						<Typography
							variant={"caption"}>{subtitle?.length > 50 ? (subtitle.slice(0, 50) + "...") : subtitle}</Typography>
						<div className={classes.flexStart} style={{marginTop: 4, marginBottom: 0}}>
							{
								users?.filter((elem) => users.indexOf(elem) <= 5).map((user, index) => {
									return (
										<Tooltip title={user} key={user}>
											<Avatar alt={user} src={`https://api.multiavatar.com/${user}.svg`}
											        style={{width: 30, height: 30, marginLeft: index >= 1 ? -15 : 0}}/>
										</Tooltip>
									)
								})
							}
							{
								users?.length > 5 &&
								<Tooltip title={users?.filter((elem) => users.indexOf(elem) > 5).join(", ")}>
									<Avatar style={{
										width: 20, height: 20, marginLeft: -15, fontSize: 12,
										backgroundColor: theme.palette.mode === "light" ? color[900] : color[50],
										color: theme.palette.mode === "light" ? color[50] : color[900],
									}}>{users.length - 5}+</Avatar>
								</Tooltip>
							}
						</div>
						<Chip label={place} icon={<PlaceTwoToneIcon style={{
							color: theme.palette.mode === "light" ? color[50] : color[900],
						}}/>} size={"small"} style={{
							position: "absolute",
							bottom: 4,
							right: 4,
							backgroundColor: theme.palette.mode === "light" ? color[600] : color[100],
							color: theme.palette.mode === "light" ? color[50] : color[900],
						}}/>
					</CardContent>
				</CardActionArea>
			</Card>
		</React.Fragment>
	);
};
